export default "__VITE_ASSET__C7A_F9Ux__"